export const TOAST_TYPE = Object.freeze({
    BLANK: 'blank',
    ERROR: 'error',
    SUCCESS: 'success',
});
export const DURATION = 5000;
//# sourceMappingURL=constants.js.map